module.exports = __webpack_public_path__ + "static/assets/ff013fbcd6ce2958e3b0f3e9cc212b47.png";